import { reactive } from 'vue'

type ToastType = 'info' | 'success' | 'error'

interface Toast {
  id: number
  message: string
  type: ToastType
}

interface ConfirmDialog {
  id: number
  message: string
  resolve: (value: boolean) => void
}

let nextId = 1

const state = reactive({
  toasts: [] as Toast[],
  confirms: [] as ConfirmDialog[]
})

export const uiStore = {
  state,

  toast(message: string, type: ToastType = 'info', duration = 4000) {
    const id = nextId++
    state.toasts.push({ id, message, type })
    setTimeout(() => {
      const idx = state.toasts.findIndex(t => t.id === id)
      if (idx !== -1) state.toasts.splice(idx, 1)
    }, duration)
  },

  confirm(message: string): Promise<boolean> {
    return new Promise(resolve => {
      state.confirms.push({ id: nextId++, message, resolve })
    })
  },

  _resolveConfirm(id: number, value: boolean) {
    const idx = state.confirms.findIndex(c => c.id === id)
    if (idx !== -1) {
      state.confirms[idx].resolve(value)
      state.confirms.splice(idx, 1)
    }
  }
}
